module.exports = __webpack_public_path__ + "static/media/thumbnail.ae60f562.jpg";